/**
 * author zhang.yingyu
 * createTime 2019-05-13
 **/
angular.module("cooperationGroupModule", [])
    .controller("cooperationGroupCtrl", ['$scope', '$q', '$modal', '$state', 'trsHttpService', '$filter', 'modalDialog', 'trsspliceString', '$validation', '$timeout', '$element', function($scope, $q, $modal, $state, trsHttpService, $filter, modalDialog, trsspliceString, $validation, $timeout, $element) {
        initStatus();
        initData();
        /**
         * [initStatus 初始化状态]
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.page = {
                "CURRPAGE": 1,
                "PAGESIZE": 10,
                "ITEMCOUNT": 0,
                "PAGECOUNT": 1,
            };
            $scope.status = {
                copyCurrPage: 1,
                tenantStatus: [
                    { name: "全部状态", value: "" },
                    { name: "已启用", value: 0 },
                    { name: "未启用", value: 1 },
                ],
                searchInitData: "",
                maxSortNum: $state.params.maxsortnum,
                isHasEdit: $state.params.objectid ? true : false,
            };
            $scope.saveGroupParams = {};
            $scope.data = {
                selectedArray: [],
                revokeSelectTenantData: [],
            };
            $scope.tenantDetail = {
                GROUPSTATUS: '1',
            };
            getTenantType().then(function(data) {
                $scope.status.tenantType = data;
                $scope.status.selectedTenantType = angular.copy($scope.status.tenantType[0]);
            });
            $scope.status.tenantStatusSelected = angular.copy($scope.status.tenantStatus[1]);
            $scope.queryAllTenantsParams = {
                serviceid: "mlf_tenant",
                methodname: "queryTenants",
                CURRPAGE: $scope.page.CURRPAGE,
                PAGESIZE: $scope.page.PAGESIZE,
                STATUS: $scope.status.tenantStatusSelected.value,
            };
        }
        /**
         * [initData 初始化数据]
         * @return {[type]} [description]
         */
        function initData() {
            if ($state.params.objectid) {
                requestData();
            }
            queryAllTenantsData();
        }
        /**
         * [getTenantType description]企业类型初始化下拉菜单
         */
        function getTenantType() {
            var deffer = $q.defer();
            var params = {
                serviceid: "mlf_tenant",
                methodname: "findIndustryByConfig",
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "post").then(function(data) {
                for (var i = 0; i < data.length; i++) {
                    data[i] = { name: data[i], value: data[i] };
                }
                data.unshift({ name: "全部企业类型", value: "" }); //添加
                deffer.resolve(data);
            });
            return deffer.promise;
        }
        /**
         * [requestData description]查询指定合作分组
         * @return {[type]} [description]
         */
        function requestData() {
            var params = {
                serviceid: "mlf_cooperationgroup",
                methodname: "findGroupById",
                ObjectId: $state.params.objectid,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope.tenantDetail = data;
                $scope.data.selectTenantData = data.TENANTS;
            });
        };
        /**
         * [queryAllTenantsData description]获取租户列表
         * @return {[type]} [description]
         */
        function queryAllTenantsData() {
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.queryAllTenantsParams, 'get').then(function(data) {
                $scope.data.allTenantData = data.DATA;
                $scope.page.ITEMCOUNT = data.PAGER.ITEMCOUNT;
                $scope.page.PAGESIZE = data.PAGER.PAGESIZE;
            });
        }
        /**
         * [queryByDropdown description]删选租户数据
         * @return {[type]} [description]
         */
        $scope.queryByDropdown = function(type, item) {
            if (type === "tenantStatusSelected") {
                if (item.value === "") delete $scope.queryAllTenantsParams.STATUS;
                else $scope.queryAllTenantsParams.STATUS = item.value;
            }
            if (type === "selectedTenantType") {
                if (item.value === "") delete $scope.queryAllTenantsParams.TYPE;
                else $scope.queryAllTenantsParams.TYPE = item.value;
            }
            // if (type === "searchData") {
            //     $scope.queryAllTenantsParams.SEARCHVALUE = $scope.status.searchInitData;
            // }
            $scope.status.copyCurrPage = 1;
            queryAllTenantsData();
        };
        /**
         * [searchFun 检索函数]
         * @return {[type]} [description]
         */
        $scope.searchFun = function(event) {
            if (!!event && event.keyCode != 13) {
                return;
            }
            if ($scope.status.searchInitData !== "") $scope.queryAllTenantsParams.SEARCHVALUE = $scope.status.searchInitData;
            else delete $scope.queryAllTenantsParams.SEARCHVALUE;
            queryAllTenantsData();
        };
        /**
         * [getFormatTime description] 获取格式化后的时间
         */
        $scope.getFormatTime = function(time) {
            if (!!time) {
                return $filter('date')(new Date(time), 'yyyy-MM-dd');
            }
        };

        function saveGroupData() {
            var deffer = $q.defer();
            var params = {
                serviceid: "mlf_cooperationgroup",
                methodname: "saveGroup",
                ObjectId: $state.params.objectid ? $state.params.objectid : 0,
                GROUPNAME: $scope.tenantDetail.GROUPNAME,
                TENANTIDS: trsspliceString.spliceString($scope.data.selectTenantData, "TENANTID", ","),
                GROUPSTATUS: $scope.tenantDetail.GROUPSTATUS,
                ORDER: $scope.tenantDetail.ORDER,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "post").then(function(data) {
                deffer.resolve(data);
            });
            return deffer.promise;
        };
        /**
         * [cancel description] 保存数据
         * @return {[type]} [description]
         */
        $scope.save = function() {
            $validation.validate($scope.cooperationGroup).success(function() {
                if (JSON.stringify($scope.data.selectTenantData) === '[]') {
                    modalDialog.alertType('未选中合作租户', '', 'warning', false, function() {});
                    return;
                };
                saveGroupData().then(function(data) {
                    $scope.status.alertInfo = ($scope.status.isHasEdit ? '编辑' : '新建') + (data ? '合作分组成功' : '合作分组失败');
                    modalDialog.alertType($scope.status.alertInfo, '', 'success', false, function() {
                        window.history.go(-1);
                    });
                });
            }).error(function() {
                $timeout(function() {
                    angular.invalidPosition($scope.cooperationGroup, $element);
                });
            });
        };
        $scope.getMaxSortNum = function() {
            return $scope.status.isHasEdit ? parseInt($scope.status.maxSortNum) : parseInt($scope.status.maxSortNum) + 1;
        }
        /**
         * [cancel description] 取消
         * @return {[type]} [description]
         */
        $scope.cancel = function() {
            window.history.go(-1);
        };
        /**
         * [switchBen description单选]
         */
        $scope.switchBtn = function() {
            $scope.tenantDetail.GROUPSTATUS = $scope.tenantDetail.GROUPSTATUS === '0' ? '1' : '0';
        };
        /**
         * [selectAll description] 列表全选按钮
         * @return {[type]} [description]
         */
        $scope.selectAll = function() {
            $scope.data.selectedArray = $scope.data.selectedArray.length == $scope.data.allTenantData.length ? [] : [].concat($scope.data.allTenantData);
        };
        /**
         * [selectDoc description] 列表单选按钮
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.selectDoc = function(item, type) {
            var index = $scope.data[type].indexOf(item);
            if (index < 0) {
                $scope.data[type].push(item);
            } else {
                $scope.data[type].splice(index, 1);
            }
        };
        /**
         * [getTenantData description] 选择租户数据
         * @return {[type]} [description]
         */
        $scope.getTenantData = function() {
            if ($scope.status.isHasEdit) {
                excludeRepeat();
            } else {
                $scope.data.selectTenantData = angular.copy($scope.data.selectedArray);
            }
        };

        function excludeRepeat() {
            var n, temp;
            temp = angular.copy($scope.data.selectedArray);
            for(var i = 0; i < temp.length; i ++) {
                for (var k = 0; k < $scope.data.selectTenantData.length; k ++) {
                    if (temp[i] && temp[i].TENANTID == $scope.data.selectTenantData[k].TENANTID) {
                        temp.splice(i, 1);
                        i = 0;
                    }
                }
            }
            $scope.data.selectTenantData = temp.concat($scope.data.selectTenantData);
        }
        /**
         * [revokeTenantData description] 撤销选择租户数据
         * @return {[type]} [description]
         */
        $scope.revokeTenantData = function() {
            for (var i = 0, data = $scope.data.revokeSelectTenantData; i < data.length; i++) {
                for (var j = 0, sData = $scope.data.selectTenantData; j < sData.length; j++) {
                    if (data[i].TENANTID === sData[j].TENANTID) {
                        $scope.data.selectTenantData.splice(j, 1);
                    }
                }
            }
            $scope.data.revokeSelectTenantData = [];
        };
        /** [selectPageNum description] 每页显示的数据数量
         */
        $scope.selectPageNum = function() {
            $scope.status.copyCurrPage = 1;
            queryAllTenantsData();
        };
        /**
         * [pageChanged description] 下一页 页面改变调取数据
         * @return {[type]} [description]
         */
        $scope.pageChanged = function() {
            $scope.status.copyCurrPage = $scope.page.CURRPAGE;
            $scope.queryAllTenantsParams.CURRPAGE = $scope.status.copyCurrPage;
            console.log($scope.page.CURRPAGE, $scope.status.copyCurrPage);
            queryAllTenantsData();
        };
        /**
         * [jumpToPage description] 跳转页
         * @return {[type]} [description]
         */
        $scope.jumpToPage = function() {
            if ($scope.status.copyCurrPage > $scope.page.PAGECOUNT) {
                $scope.status.copyCurrPage = $scope.page.PAGECOUNT;
            }
            $scope.page.CURRPAGE = $scope.status.copyCurrPage;
            queryAllTenantsData();
        };
    }]);